import React, { FC } from 'react';

import { faTrashCan } from '@fortawesome/free-solid-svg-icons';

import { AbstractIcon } from '../abstract-icon';

interface Props {
  className?: string;
}

const TrashIcon: FC<Props> = props => <AbstractIcon {...props} icon={faTrashCan} />;

export { TrashIcon };